import { STAFF_ROLES, type Role } from '@menage/shared';
import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';
import { ListSkeleton } from '@/components/common';
import { homePathFor, useAuth } from '@/lib/auth/AuthProvider';

/** Route guard by role family. Permission checks inside the portal are done per screen/action. */
export function RequireRole({ roles, children }: { roles: readonly Role[]; children: ReactNode }) {
  const { status, actor } = useAuth();
  const location = useLocation();
  if (status === 'loading') {
    return (
      <div className="mx-auto max-w-3xl p-6">
        <ListSkeleton rows={4} />
      </div>
    );
  }
  if (!actor) return <Navigate to={`/connexion?next=${encodeURIComponent(location.pathname + location.search)}`} replace />;
  if (!roles.includes(actor.role)) return <Navigate to={homePathFor(actor)} replace />;
  return <>{children}</>;
}

export const RequireStaff = ({ children }: { children: ReactNode }) => <RequireRole roles={STAFF_ROLES}>{children}</RequireRole>;

/** /app: sends each user to their portal. */
export function HomeRedirect() {
  const { status, actor } = useAuth();
  if (status === 'loading') return null;
  return <Navigate to={actor ? homePathFor(actor) : '/connexion'} replace />;
}
